/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { ApiConnectionsModel } from '../models';
import { CentralDatabaseKeys } from './central-database-keys';
import { AppVariables } from '@shared';

export const centralApiConnectionsSchema: RxJsonSchema<ApiConnectionsModel> = {
	version: 0,
	primaryKey: CentralDatabaseKeys.apiConnections_connectionId,
	properties: {
		[CentralDatabaseKeys.apiConnections_connectionId]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[CentralDatabaseKeys.apiConnections_serverPath]: {
			type: 'string'
		},
		[CentralDatabaseKeys.apiConnections_apiKey]: {
			type: 'string'
		},
		[CentralDatabaseKeys.apiConnections_serverAlias]: {
			type: 'string'
		},
		[CentralDatabaseKeys.apiConnections_selectedOptions]: {
			type: ['object', 'null'],
			properties: {
				database: {
					type: 'string'
				},
				businessUnit: {
					type: 'string'
				},
				sstnLoggingStyle: {
					type: ['string', 'null']
				},
				dhlLoggingStyle: {
					type: ['string', 'null']
				}
			}
		}
	},
	type: 'object',
	description: 'Store API connection details and transfer out options.'
};
